import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CucurbItNgxAnimatedBootstrapButtonModule } from '@cucurb-it/ngx-animated-bootstrap-button';
import { TranslateModule } from '@ngx-translate/core';
import { ModalFormHostComponent } from './modal-form-host.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        CucurbItNgxAnimatedBootstrapButtonModule
    ],
    declarations: [ModalFormHostComponent],
    exports: [ModalFormHostComponent]
})
export class ModalFormHostModule {}
